import {DatabaseCode, getDatabaseCode, toDatabaseCode} from "./database-code";
import {FreightTypeEntity} from "./freight-type";
import {ServiceTypeEntity} from "./service-type";
import {CargoSubtype, cargoSubtype} from "./cargo-subtype";

/**
 * The category of transport
 */
export interface TransportCategory extends DatabaseCode {
    cargoSubtype?: CargoSubtype
}

const water: TransportCategory = {
    code: 'WATER',
    displayValue: {
        id: 'common.entity.transport.category.water',
        defaultMessage: 'Water',
    },
    cargoSubtype: cargoSubtype.water
};

const oil: TransportCategory = {
    code: 'OIL',
    displayValue: {
        id: 'common.entity.transport.category.oil',
        defaultMessage: 'Oil',
    },
    cargoSubtype: cargoSubtype.oil
};

export const transportCategory = {
    water,
    oil,
};

export const transportCategories = Object.values(transportCategory);

export const toTransportCategory = (code: string): TransportCategory => toDatabaseCode(code, transportCategories);
export const getTransportCategory = (code: string | undefined): TransportCategory | undefined => getDatabaseCode(code, transportCategories);


/**
 * Implement this interface when an entity can
 * be transport categorized.
 */
export interface TransportCategorizable {
    category: TransportCategory;
}

export const categorize = (freightType?: FreightTypeEntity, serviceType?: ServiceTypeEntity): TransportCategory => {
    let category = transportCategory.water;

    if (serviceType) {
        category = transportCategory.water;
    } else if (
        freightType &&
        freightType.cargoSubType === cargoSubtype.oil.code
    ) {
        category = transportCategory.oil;
    }

    return category;
};
